import { Component, HostListener, OnDestroy, OnInit,inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LoginapiService } from 'src/app/Apicalls/LoginApicall/loginapi.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'autoliv';
  cookieService = inject(CookieService);
  constructor(private router: Router, public snackBar: MatSnackBar,    readonly apiCallsService: LoginapiService,
  ) {}

  ngOnInit(): void {
  // Check token on initialization to ensure user stays logged in across sessions
    this.handleToken();
    this.retriveLastRoute();
    this.storeLastRoute();
  }
 // Retrieve the last visited route from localStorage
  retriveLastRoute() {
    const lastRoute = localStorage.getItem('lastRoute');
    if (lastRoute) {
      // Navigate to the last route stored in localStorage
      this.router.navigateByUrl(lastRoute);
    } else {
      // Default route if no route is stored
      this.router.navigate(['/dashboard/landing']);
    }
  }
  // Subscribe to NavigationEnd events to store the latest route in localStorage
  storeLastRoute() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Store the current route in localStorage
        localStorage.setItem('lastRoute', event.urlAfterRedirects);
      }
    });
  }

  handleToken(): void {
    const token = localStorage.getItem('user'); // token persists across sessions
    if (token) {
      try {
        const tokenPayload = token.split('.')[1]; // Extract the payload
        const decodedPayload = atob(tokenPayload);
        const decodedPayloadJson = JSON.parse(decodedPayload);
        // const expirationTime = decodedPayloadJson.exp; // Expiration time from the token
        const currentTime = Math.floor(Date.now() / 1000);

        // If token is expired, log the user out
        // if (currentTime >= expirationTime) {
        //   this.logout();
        //   setTimeout(() => {
        //     this.openSnackBar();
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 500);
        //   }, 100);
        // } else {
        //   // If token is still valid, set a timeout to log out the user when it expires
        //   const timeUntilLogout = expirationTime - currentTime;
        //   setTimeout(() => {
        //     this.logout();
        //     this.openSnackBar();
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 1000);
        //   }, timeUntilLogout * 1000); // Automatically logout at expiration time
        // }
      } catch (error) {
        console.error('Error decoding token:', error);
        this.logout();
      }
    }
  }

  ngOnDestroy(): void {
    // Any cleanup logic if needed
  }

  openSnackBar(): void {
    this.snackBar.open('Session Timeout', '', {
      duration: 2000,
    });
  }

  logout(): void {
    // Call the logout API
    const logoutMessage = { message: 'User logged out' };
    this.apiCallsService.logout(logoutMessage).subscribe({
      next: (response) => {
        console.log(response.message); // Example: Backend responds with success message
  
        // Clear local storage
        localStorage.clear();
  
        // Clear session storage
        sessionStorage.clear();
  
        // Clear cookie 
        this.cookieService.delete('vicas_token');

        // Navigate to the login page
        this.router.navigate(['/login']);
      },
      error: (error) => {
        console.error('Error during logout:', error);
        alert('Logout failed. Please try again.');
      },
    });
  }
}
